const mfa = {
    totp: 'Mã OTP từ ứng dụng xác thực',
    webauthn: 'Mã khóa',
    backup_code: 'Mã dự phòng',
    link_totp_description: 'Ví dụ: Google Authenticator, v.v.',
    link_webauthn_description: 'Liên kết thiết bị hoặc phần cứng USB của bạn',
    link_backup_code_description: 'Tạo mã dự phòng',
    verify_totp_description: 'Nhập mã một lần trong ứng dụng',
    verify_webauthn_description: 'Xác minh thiết bị hoặc phần cứng USB của bạn',
    verify_backup_code_description: 'Dán mã dự phòng bạn đã lưu',
    add_mfa_factors: 'Thêm xác thực 2 bước',
    add_mfa_description: 'Xác thực hai yếu tố đã được kích hoạt. Chọn phương thức xác thực thứ hai của bạn để đăng nhập an toàn.',
    verify_mfa_factors: 'Xác thực 2 bước',
    verify_mfa_description: 'Xác thực 2 bước đã được kích hoạt cho tài khoản này. Vui lòng chọn cách thứ hai để xác minh danh tính của bạn.',
    add_authenticator_app: 'Thêm ứng dụng xác thực',
    step: 'Bước {{step, number}}: {{content}}',
    scan_qr_code: 'Quét mã QR này',
    scan_qr_code_description: 'Quét mã QR sau bằng ứng dụng xác thực của bạn, chẳng hạn như Google Authenticator, Duo Mobile, Authy, v.v.',
    qr_code_not_available: 'Không thể quét mã QR?',
    copy_and_paste_key: 'Sao chép và dán khóa',
    copy_and_paste_key_description: 'Sao chép và dán khóa sau vào ứng dụng xác thực của bạn, chẳng hạn như Google Authenticator, Duo Mobile, Authy, v.v.',
    want_to_scan_qr_code: 'Bạn có muốn quét mã QR không?',
    enter_one_time_code: 'Nhập mã một lần',
    enter_one_time_code_link_description: 'Nhập mã xác minh 6 chữ số được tạo bởi ứng dụng xác thực.',
    enter_one_time_code_description: 'Xác thực 2 bước đã được kích hoạt cho tài khoản này. Vui lòng nhập mã một lần hiển thị trên ứng dụng xác thực đã liên kết của bạn.',
    link_another_mfa_factor: 'Chuyển sang phương pháp khác',
    save_backup_code: 'Lưu mã dự phòng của bạn',
    save_backup_code_description: 'Bạn có thể sử dụng một trong những mã dự phòng này để truy cập tài khoản của mình nếu gặp khó khăn trong quá trình xác thực 2 bước theo cách khác. Mỗi mã chỉ có thể được sử dụng một lần.',
    backup_code_hint: 'Hãy chắc chắn sao chép chúng và lưu ở nơi an toàn.',
    enter_a_backup_code: 'Nhập mã dự phòng',
    enter_backup_code_description: 'Nhập mã dự phòng bạn đã lưu khi xác thực 2 bước được kích hoạt lần đầu.',
    create_a_passkey: 'Tạo mã khóa',
    create_passkey_description: 'Đăng ký mã khóa của bạn bằng cách sử dụng sinh trắc học thiết bị, khóa bảo mật (ví dụ: YubiKey) hoặc các phương pháp có sẵn khác.',
    try_another_verification_method: 'Thử phương pháp xác minh khác',
    verify_via_passkey: 'Xác minh qua mã khóa',
    verify_via_passkey_description: 'Sử dụng mã khóa để xác minh bằng mật khẩu thiết bị hoặc sinh trắc học, quét mã QR, hoặc sử dụng khóa bảo mật USB như YubiKey.',
    secret_key_copied: 'Khóa bí mật đã được sao chép.',
    backup_code_copied: 'Mã dự phòng đã được sao chép.',
    webauthn_not_ready: 'WebAuthn chưa sẵn sàng. Vui lòng thử lại sau.',
    webauthn_not_supported: 'WebAuthn không được hỗ trợ trên trình duyệt này.',
    webauthn_failed_to_create: 'Tạo không thành công. Vui lòng thử lại.',
    webauthn_failed_to_verify: 'Xác minh không thành công. Vui lòng thử lại.',
};
export default Object.freeze(mfa);
